import React, { useEffect, useState, useContext, useRef } from "react";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import Image from "next/image";
import Link from "next/link";
import { Menu as MenuIcon, X } from "react-feather";
import { Container, Box, Typography, Drawer, Grid } from "@mui/material";
import { CHANGE_LANG } from "context/actions/auth";
import { GlobalContext } from "context";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import useWindowSize from "utils/useWindowSize";
import { getPageList } from "context/actions/pages";

const HeaderHeight = 90;

const Header = () => {
  const { sizes } = useWindowSize();
  const { t } = useTranslation();
  const router = useRouter();
  const divRef = useRef(null);
  const divRef2 = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const { state, dispatch } = useContext(GlobalContext);
  const [showMenu, setShowMenu] = useState(false);
  const [menus, setMenus] = useState([]);
  const [absoluteMenus, setAbsoluteMenus] = useState([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        divRef.current &&
        !divRef.current.contains(event.target) &&
        !divRef2.current.contains(event.target)
      ) {
        setAbsoluteMenus([]);
      }
    };

    const handleScroll = () => {
      setScrollTop(window.pageYOffset);
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const getMenus = async () => {
      const datas = await getPageList(true);
      if (datas.status === "success") {
        setMenus(datas.data);
      }
    };
    getMenus();
  }, []);

  const handleMenuButtonClick = () => {
    setShowMenu((prev) => !prev);
  };

  const handleDrawerClose = () => {
    setShowMenu(false);
  };

  const handleRoteClick = (menu) => {
    showMenu && handleDrawerClose();
    if ((menu.url && menu.url.charAt(0) === "/") || !menu.url) {
      router.push(menu.url ? menu.url : `/content/${menu.id}`);
    } else {
      window.open(menu.url, "_blank", "noopener,noreferrer");
    }
  };

  const RenderMenu = ({ position, menu, type = "header" }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    return (
      <div
        onMouseEnter={() => setShowSubMenu(true)}
        onMouseLeave={() => setShowSubMenu(false)}
        style={{ position: "relative" }}
      >
        <li
          style={{
            position: "relative",
            height:
              type === "drawer" ? 30 : position === menus.length - 1 ? 35 : 80,
            display: "flex",
            // marginTop: position === menus.length - 1 ? 22.5 : 0,
            justifyContent: "left",
            alignItems: "center",
            paddingLeft: 10,
            paddingRight: 10,
            cursor: "pointer",
            textTransform: "uppercase",
            fontSize: 12,
            borderRadius: 6,
            color: position === menus.length - 1 ? "#0a2458" : "white",
            backgroundColor:
              position === menus.length - 1
                ? showSubMenu
                  ? "#ffb000"
                  : "white"
                : "",
          }}
          className="transition-colors duration-300"
        >
          {menu.children && menu.children.length > 0 ? (
            i18n.language === "mn" ? (
              menu.name
            ) : (
              menu.nameEng
            )
          ) : (
            <Link
              href={menu.url ? menu.url : `/content/${menu.id}`}
              target={
                (menu.url && menu.url.charAt(0) === "/") || !menu.url
                  ? "_self"
                  : "_blank"
              }
            >
              {i18n.language === "mn" ? menu.name : menu.nameEng}
            </Link>
          )}
        </li>
        {menu.children && menu.children.length > 0 && (
          <div
            style={{
              position: "absolute",
              top: 63,
              left: position > 2 ? null : "0%",
              right: position > 2 ? "20%" : null,
              backgroundColor: "white",
              borderRadius: 10,
              zIndex: 100,
              boxShadow: "3px 3px 16px rgba(0, 0, 0, 0.3)",
            }}
          >
            <ul style={{ position: "relative" }}>
              {menu.children.map((m, ind) => (
                <RenderSubMenu
                  key={m.id || ind}
                  menu={m}
                  showsMenu={showSubMenu}
                />
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };

  const RenderSubMenu = ({ menu, showsMenu = true }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    return (
      <Box
        onMouseEnter={() => setShowSubMenu(true)}
        onMouseLeave={() => setShowSubMenu(false)}
        style={{ position: "relative" }}
      >
        <li
          style={{
            position: "relative",
            color: "gray",
            cursor: "pointer",
            display: showsMenu ? "block" : "none",
            backgroundColor: showSubMenu ? "#bee0f8" : "#fff",
            paddingLeft: 40,
            paddingRight: 40,
            paddingTop: 8,
            paddingBottom: 8,
          }}
        >
          {menu.children && menu.children.length > 0 ? (
            <Typography noWrap variant="body2" className="p-2">
              {i18n.language === "mn" ? menu.name : menu.nameEng}
            </Typography>
          ) : (
            <Link
              href={menu.url ? menu.url : `/content/${menu.id}`}
              target={
                (menu.url && menu.url.charAt(0) === "/") || !menu.url
                  ? "_self"
                  : "_blank"
              }
            >
              <Typography noWrap variant="body2" className="p-2">
                {i18n.language === "mn" ? menu.name : menu.nameEng}
              </Typography>
            </Link>
          )}
        </li>
        {menu.children && menu.children.length > 0 && (
          <div
            style={{
              position: "absolute",
              right: "95%",
              maxWidth: 600,
              top: 0,
              backgroundColor: "white",
              borderRadius: 10,
              zIndex: 101,
              boxShadow: "3px 3px 16px rgba(0, 0, 0, 0.3)",
            }}
          >
            <ul style={{ position: "relative" }}>
              {menu.children.map((m, ind) => (
                <RenderSubMenu
                  key={m.id || ind}
                  menu={m}
                  showsMenu={showSubMenu}
                />
              ))}
            </ul>
          </div>
        )}
      </Box>
    );
  };

  const RenderToggleMenu = ({ menu, type = "header" }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    return (
      <div onClick={() => setShowSubMenu(!showSubMenu)}>
        <li
          style={{
            position: "relative",
            height: type === "drawer" ? 30 : 80,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: 10,
            paddingRight: 10,
            cursor: "pointer",
            color: type === "drawer" ? "black" : "white",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          {menu.children && menu.children.length > 0 ? (
            <>
              {i18n.language === "mn" ? menu.name : menu.nameEng}
              <div>{showSubMenu ? "-" : "+"}</div>
            </>
          ) : (
            <Typography
              variant="h4"
              sx={{
                color: "#000",
                fontWeight: 700,
                cursor: "pointer",
                marginRight: "46px",
                "&:hover": { color: "#a19d9d" },
              }}
              onClick={() => handleRoteClick(menu)}
            >
              {i18n.language === "mn" ? menu.name : menu.nameEng}
            </Typography>
          )}
        </li>
        {menu.children && menu.children.length > 0 && (
          <ul>
            {menu.children.map((m, ind) => (
              <RenderToggleSubMenu
                key={m.id || ind}
                menu={m}
                showsMenu={showSubMenu}
              />
            ))}
          </ul>
        )}
      </div>
    );
  };

  const RenderToggleSubMenu = ({ menu, showsMenu = true }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    return showsMenu ? (
      <div>
        <li
          onMouseEnter={() => setShowSubMenu(true)}
          onMouseLeave={() => setShowSubMenu(false)}
          style={{
            position: "relative",
            color: "gray",
            cursor: "pointer",
            display: "flex",
            marginLeft: 30,
            padding: 10,
          }}
        >
          <Typography variant="h4" onClick={() => handleRoteClick(menu)}>
            {i18n.language === "mn" ? menu.name : menu.nameEng}
          </Typography>
        </li>
        {menu.children && menu.children.length > 0 && (
          <div style={{ position: "relative", marginLeft: 30 }}>
            {menu.children.map((m, ind) => (
              <RenderToggleSubMenu
                key={m.id || ind}
                menu={m}
                showsMenu={showSubMenu}
              />
            ))}
          </div>
        )}
      </div>
    ) : null;
  };

  return (
    <div style={{ paddingBottom: absoluteMenus.length ? 0 : 0 }}>
      <Container
        maxWidth={false}
        disableGutters
        sx={{ height: 30, backgroundColor: "#f2f2f2" }}
      >
        <Container
          maxWidth="lg"
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Link href="/contact">
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                mr: 2.5,
                color: "#616A6B",
                "&:hover": { color: "grey.600" },
              }}
            >
              {t("send_feed")}
            </Typography>
          </Link>
          {state.auth?.lang === "mn" ? (
            <Box
              sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={() => {
                i18n.changeLanguage("en");
                Cookies.set("chosen_lang", "en");
                dispatch({ type: CHANGE_LANG, data: "en" });
              }}
            >
              <Image
                width={20}
                height={20}
                src="/en.svg"
                alt="English"
                style={{
                  border: state.auth.lang === "en" ? "2px solid #fff" : "none",
                  borderRadius: 1,
                  marginRight: 4,
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  color: "#616A6B",
                  "&:hover": { color: "grey.600" },
                }}
              >
                EN
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={() => {
                i18n.changeLanguage("mn");
                Cookies.set("chosen_lang", "mn");
                dispatch({ type: CHANGE_LANG, data: "mn" });
              }}
            >
              <Image
                width={20}
                height={20}
                src="/mn.svg"
                alt="Mongolian"
                style={{
                  border: state.auth.lang === "mn" ? "2px solid #fff" : "none",
                  borderRadius: 1,
                  marginRight: 4,
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  color: "#616A6B",
                  "&:hover": { color: "grey.600" },
                }}
              >
                MN
              </Typography>
            </Box>
          )}
        </Container>
      </Container>
      <Container
        maxWidth={false}
        disableGutters
        ref={divRef2}
        sx={{
          height: HeaderHeight,
          backgroundColor: "#212F3D",
          borderBottom: "1px solid #cbcbcb75",
          position: scrollTop > 30 ? "fixed" : "absolute",
          top: scrollTop > 30 ? 0 : 30,
          zIndex: 9999,
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            height: HeaderHeight,
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Link href="/">
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Image
                width={70}
                height={70}
                src={i18n.language === "mn" ? "/12.jpg" : "/12.jpg"}
                alt="Logo"
                style={{ objectFit: "cover", borderRadius: 70 }}
              />
              <Box
                sx={{
                  textTransform: "uppercase",
                  font: "bold 16px Roboto, sans-serif",
                  color: "#fff",
                  lineHeight: 1.1,
                  m: 1.25,
                  mt: 2,
                }}
              >
                {i18n.language === "mn" ? "Ханлор эмнэлэг" : "Khanlor"}
              </Box>
            </Box>
          </Link>
          {sizes.sm ? (
            <>
              <MenuIcon
                color="#fff"
                size={40}
                sx={{ ml: "auto", cursor: "pointer" }}
                onClick={handleMenuButtonClick}
              />
              <Drawer
                anchor="right"
                open={showMenu}
                onClose={handleDrawerClose}
                transitionDuration={{ enter: 500, exit: 500 }}
                PaperProps={{ sx: { width: "100vw" } }}
                sx={{ zIndex: 10000 }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    p: 2.5,
                    height: "100%",
                    animation: showMenu ? "slideIn 350ms forwards" : "none",
                    "@keyframes slideIn": {
                      "0%": { opacity: 0.4, transform: "translateX(100px)" },
                      "100%": { opacity: 1, transform: "translateX(0)" },
                    },
                  }}
                >
                  <X
                    color="#000"
                    size={36}
                    sx={{
                      mt: 2.5,
                      mb: 0.75,
                      ml: "auto",
                      cursor: "pointer",
                      minHeight: 40,
                    }}
                    onClick={handleDrawerClose}
                  />
                  {menus.map((m, ind) => (
                    <RenderToggleMenu
                      key={m.id || ind}
                      menu={m}
                      type="drawer"
                    />
                  ))}
                </Box>
              </Drawer>
            </>
          ) : (
            <>
              {menus.map((m, ind) => (
                <RenderMenu key={m.id || ind} position={ind} menu={m} />
              ))}
            </>
          )}
        </Container>
      </Container>
    </div>
  );
};

export default Header;
